export const orientationOptions = [
    { value: 'all', name: 'Все варианты ориентации' },
    { value: 'landscape', name: 'Горизонтальная' },
    { value: 'portrait', name: 'Вертикальная' },
    { value: 'square', name: 'Квадратное изображение' },
];

export const sizeOptions = [
    { value: 'all', name: 'Все размеры' },
    { value: 'large', name: 'Большой' },
    { value: 'medium', name: 'Средний' },
    { value: 'small', name: 'Маленький' },
];

export const defaultPhoto = {
    id: 9427143,
    url: 'https://www.pexels.com/photo/classic-car-on-dirt-road-near-tree-9427143/',
    src: 'https://images.pexels.com/photos/9427143/pexels-photo-9427143.jpeg',
    photographer: 'Mr Dark_space',
    photographerURL: 'https://www.pexels.com/@mr-dark_space-84743911',
};

export const categories = [
    '35 мм',
    '4 июля',
    'абстрактный',
    'автомобиль',
    'аналоговая',
    'архитектура',
    'баланс',
    'бездорожье',
    'бизнес',
    'веселье',
    'вода',
    'гора',
    'город',
    'досуг',
    'еда',
    'живописный',
    'здание',
    'комната',
    'космос',
    'костюмы',
    'красивый',
    'лес',
    'лето',
    'мебель',
    'музей',
    'небо',
    'облака',
    'отражение',
    'офис',
    'пейзаж',
    'пляж',
    'природа',
    'путешествовать',
    'современный',
    'темный',
    'технология',
    'фотосессия',
    'футуристический',
    'цветы',
    'шаг',
];
